import { Lock, RefreshCw } from 'lucide-react';

interface AuthenticationErrorProps {
  message: string;
  onRetry?: () => void;
}

export function AuthenticationError({ message, onRetry }: AuthenticationErrorProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mx-auto mb-4">
          <Lock className="w-8 h-8 text-red-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 text-center mb-2">
          Authentication Failed
        </h1>
        
        <p className="text-gray-600 text-center mb-6">
          {message}
        </p>
        
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <h3 className="font-semibold text-red-900 mb-2">Possible Issues:</h3>
          <ul className="text-sm text-red-800 space-y-1">
            <li>• Your JWT token may have expired</li>
            <li>• Invalid authentication credentials</li>
            <li>• Insufficient permissions</li>
            <li>• Network connectivity issues</li>
          </ul>
        </div>
        
        <div className="text-center space-y-3">
          {onRetry && (
            <button
              onClick={onRetry}
              className="inline-flex items-center gap-2 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <RefreshCw className="w-4 h-4" />
              Retry Connection
            </button>
          )}
          
          <p className="text-sm text-gray-500">
            Please refresh your session or contact support.
          </p>
        </div>
      </div>
    </div>
  );
}
